import script from "./StatusProposal.vue?vue&type=script&lang=js"
export * from "./StatusProposal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__